import React, { useContext } from 'react';
import { LanguageContext } from '../../libs/Context';

const Footer = () =>
{
	const { language } = useContext(LanguageContext);

	return (
		<div className='flexRow justifyCntr pdngMD textCntr'>
			<small className='subHeadingXXS'>&copy; {new Date().getFullYear()}&nbsp;{language?.copyRightIVC}
			</small>
		</div>
	);
};

export default Footer;